import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_TAB } from '../../DashboardBirdview.constants.qa'

function BirdviewChartCatalogTab({ isActive, tab, onSelect }) {
  const { t } = useTranslation()

  function handleClick() {
    onSelect(tab.value)
  }

  return (
    <Button.Flat
      isGrey
      height={BUTTON_HEIGHT_24}
      isActive={isActive}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_TAB}
      text={t(tab.labelKey)}
      onClick={handleClick}
    />
  )
}

export default BirdviewChartCatalogTab
